// External SSO session API (cookie-based, see BE `ExternalAuthController`).

const BACKEND_URI = process.env.REACT_APP_BACKEND_URI;

/**
 * GET /auth/external/me
 * Returns `{ isAuthenticated, fullName, email, roles }` or null when the
 * session is missing or expired.
 */
export const getCurrentUser = async () => {
  const response = await fetch(`${BACKEND_URI}/auth/external/me`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) return null;

  const data = await response.json();
  return data?.isAuthenticated ? data : null;
};

/**
 * POST /auth/external/logout
 * Clears the server session and cookie. The endpoint answers with a redirect
 * to the IAM logout URL, which `fetch` must not follow (cross-origin, no CORS)
 * — `redirect: 'manual'` keeps the response opaque while the server-side
 * sign-out still happens.
 */
export const logout = () =>
  fetch(`${BACKEND_URI}/auth/external/logout`, {
    method: 'POST',
    credentials: 'include',
    redirect: 'manual',
  });
